(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROW = 4; // px; matches grid-auto-rows on .is-masonry
    var GAP = 16; // px; matches the card margin-bottom
    var nativeMasonry = window.CSS && CSS.supports && CSS.supports('grid-template-rows', 'masonry');

    function layout(grid) {
      if (nativeMasonry) return;
      var cards = grid.children;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (!card.offsetParent) continue; // collapsed extra card
        card.style.gridRowEnd = 'span ' + Math.ceil((card.getBoundingClientRect().height + GAP) / ROW);
      }
    }

    function init(grid) {
      if (grid.dataset.pkMasonryBound) return;
      grid.dataset.pkMasonryBound = 'true';

      var more = grid.parentElement.querySelector('[data-pk-masonry-more]');
      if (more) {
        grid.setAttribute('data-collapsed', '');
        more.hidden = false;
        more.addEventListener('click', function () {
          grid.removeAttribute('data-collapsed');
          more.remove();
          layout(grid);
          var first = grid.querySelector('.pk-review--extra');
          if (first) { first.setAttribute('tabindex', '-1'); first.focus({ preventScroll: true }); }
        });
      }

      if (nativeMasonry) return;
      grid.classList.add('is-masonry');
      layout(grid);

      var lastWidth = grid.clientWidth;
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          if (grid.clientWidth === lastWidth) return;
          lastWidth = grid.clientWidth;
          layout(grid);
        }).observe(grid);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(grid); });
    }

    function initAll() { document.querySelectorAll('[data-pk-masonry]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
